var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg074Save(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 21H20C20.5523 21 21 20.5523 21 20V8.99997C21.0015 8.73417 20.8972 8.47869 20.71 8.28997L15.71 3.28997C15.5213 3.10279 15.2658 2.99844 15 2.99997H4C3.44772 2.99997 3 3.44769 3 3.99997V20C3 20.5523 3.44772 21 4 21ZM14 19H10V14H14V19ZM5 4.99997H14.59L19 9.40997V19H16V13C16 12.4477 15.5523 12 15 12H9C8.44772 12 8 12.4477 8 13V19H5V4.99997Z",
    fill: "#8199A6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg074Save);
export default __webpack_public_path__ + "static/media/074-save.cc3d650d804fc80acff6bd8a8f103d45.svg";
export { ForwardRef as ReactComponent };